import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
const { Modal, Box, Button } = MaterialUiCore;

export default ({ modalShow, setModalShow }) => {
    function renderPointer(label, index) {
        return (
            <li
                key={index}
                style={{
                    fontSize: '1rem',
                    marginBottom: '1rem',
                    color: 'black',
                    display: 'list-item',
                    listStylePosition: 'inside',
                }}
            >
                {label}
            </li>
        );
    }
    const pointers = [
        'The tool is powered by generative AI.',
        'It may make mistakes and that all outputs should be validated before sharing or relying upon them for decisions.',
        'You may input sensitive data, but DO NOT input highly sensitive data into the tool such as Social Security Numbers, Wal-Mart restricted data, medical information, etc.',
        'The use of the application is governed by the internal generative AI guidelines.',
    ];
    const title = 'GSCOPE Chatbot';
    const subtitle = 'Disclaimer';
    const buttonLabel = 'Understood';

    const styles = {
        title: { marginBottom: '0.75rem', fontSize: '1.35rem', fontWeight: 600 },
        subtitle: { marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600 },
        footer: { display: 'flex', marginTop: '2.5rem', justifyContent: 'flex-end' },
    };
    return (
        <Modal
            open={modalShow}
            onClose={() => setModalShow(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ position: 'absolute', inset: '25% 40% 0px', padding: '16px', outline: 'none' }}
            data-testid="chatbot-disclaimer-modal"
        >
            <Box sx={{ background: 'white', width: '400px', padding: '10px', borderRadius: '8px' }}>
                <h2 style={styles.title}>{title}</h2>
                <h2 style={styles.subtitle}>{subtitle}</h2>
                <ol>{pointers.map((e, i) => renderPointer(e, i))}</ol>
                <div style={styles.footer}>
                    <Button
                        data-testid="dismiss-chatbot-disclaimer"
                        style={{ backgroundColor: '#0071dc', color: 'white' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setModalShow(false);
                        }}
                    >
                        {buttonLabel}
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};
